<template>
  <div class="safe-report body">
    <el-container>
      <!-- <SafeAside /> -->
      <el-main>
        <div class="mt-2">
          <el-row :gutter="10">
            <el-col :xl="3" :lg="3" :md="10" :sm="12" class="oreder-1">
              <div class="bg-White p-3">
                <label for="search" class="block">بداية الفترة</label>
                <el-input
                  id="paied"
                  readonly
                  type="number"
                  @focus="$event.target.select()"
                  v-model="taslimForm.start_amount"
                  controls-position="right"
                  @keyup.enter.native="setNotesFocus"
                ></el-input>
              </div>
            </el-col>
            <el-col :xl="3" :lg="3" :md="10" :sm="12" class="oreder-2">
              <div class="bg-White p-3">
                <label class="block" for="search">الرصيد الحالي</label>
                <el-input
                  id="paied"
                  readonly
                  type="number"
                  @focus="$event.target.select()"
                  v-model="taslimForm.end_amount"
                  controls-position="right"
                  @keyup.enter.native="setNotesFocus"
                ></el-input>
              </div>
            </el-col>
            <el-col :xl="16" :lg="16" :md="24" :sm="24" class="oreder-4">
              <el-row class="bg-White p-3" :gutter="10">
                <el-col :md="8" :sm="12">
                  <label for="search" class="block">المُستلم</label>
                  <el-select style="width: 100%" v-model="taslimForm.to_user">
                    <!-- placeholder="حدد المستلم" -->
                    <!-- @change="focusNext" -->
                    <el-option
                      v-for="item in users"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :md="14" :sm="12">
                  <label class="block" for="search">ملاحظات</label>
                  <el-input
                    type="text"
                    id="notes"
                    @focus="$event.target.select()"
                    v-model="taslimForm.note"
                    controls-position="right"
                  ></el-input>
                </el-col>
                <el-col :md="2" :sm="12">
                  <br />
                  <el-button type="warning" @click="storeTaslim()">
                    تسليم</el-button
                  >
                </el-col>
              </el-row>
            </el-col>
            <el-col :xl="2" :lg="2" :md="4" :sm="12" class="oreder-3">
              <div class="bg-White p-3">
                <el-button
                  style="margin-top: 22px"
                  type="success"
                  title="طباعه"
                  icon="el-icon-printer"
                  @click="sendToPrintAll(tableData)"
                ></el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-table
          class="mt-2"
          align="right"
          v-if="tableData.length > 0"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column width="60" label="السند" prop="id">
          </el-table-column>
          <el-table-column sortable width="150" label="التوقيت" prop="donne_at">
            <template slot-scope="scope">
              {{ scope.row.donne_at | moment("Do / MM / YYYY | h:mm A") }}
            </template>
          </el-table-column>
          <el-table-column width="150" label="بيان" prop="comment">
          </el-table-column>
          <el-table-column width="110" label="المستفيد" prop="for_who">
          </el-table-column>
          <el-table-column label="دائن">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 1">{{ scope.row.cost }}</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column label=" مدين">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 0">{{ scope.row.cost }}</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column label="الرصيد">
            <template slot-scope="scope">
              {{ numberToFixed(scope.row.account) }}
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>
<script>
// import SafeAside from "@/components/SafeAside.vue";
import axiosApi from "@/plugins/axios.js";
// import { ipcRenderer } from "electron";

export default {
  name: "CustomerReport",
  // components: { SafeAside },
  data() {
    return {
      branch_id: JSON.parse(localStorage.getItem("user")).branch_id,
      old_branch_account: 0,
      inCashDrawer: 0,
      outCashDrawer: 0,
      false: false,
      true: true,
      dateRange: null,
      users: [],
      tableData: [],
      lastTaslim: null,
      taslimForm: {
        to_user: "",
        start_amount: 0,
        end_amount: 0,
        inventory_id: JSON.parse(localStorage.getItem("user_inventories"))[0]
          .id,
        note: "",
      },
    };
  },
  created() {
    this.getLastTaslim();
    this.getUsers();
  },
  methods: {
    taslim() {
      alert("d");
    },
    getUsers() {
      let branch_id = JSON.parse(localStorage.getItem("user_inventories"))[0]
        .id;
      console.log("branch_id", branch_id);
      axiosApi
        .get(`branch/${branch_id}/users`)
        .then((response) => {
          this.users = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    goTo(routerName) {
      this.$router.push({ path: routerName });
    },
    storeTaslim() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let url = `safe/taslim`;

      axiosApi
        .post(url, this.taslimForm)
        .then(() => {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          this.goTo("/login");
          this.$message({
            type: "success",
            message: "تم تسليم الخزينة بنجاح",
          });
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
        });
    },
    getLastTaslim() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let url = `safe/taslim/${this.taslimForm.inventory_id}`;
      axiosApi
        .get(url)
        .then((res) => {
          if (res.data.length > 0) {
            this.lastTaslim = res.data;
            this.taslimForm.start_amount = res.data[0].end_amount;
          }
          this.getCurrentSafeState();
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
        });
    },
    getCurrentSafeState() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .get(`safe/report/${this.taslimForm.inventory_id}`)
        .then((response) => {
          this.tableData = response.data.details;
          this.old_branch_account = response.data.old_branch_account;
          let sum = response.data.old_branch_account;
          let inCash = response.data.old_branch_account;
          let outCash = 0;
          if (response.data.details.length > 0) {
            this.tableData.map(function (value) {
              value["in"] = "";
              value["out"] = "";
              if (value["type"] == 1) {
                sum += Number(value["cost"]);
                inCash += Number(value["cost"]);
              } else {
                sum -= Number(value["cost"]);
                outCash += Number(value["cost"]);
              }
              value["account"] = sum;
            });
          }
          this.inCashDrawer = inCash;
          this.outCashDrawer = outCash;
          this.taslimForm.end_amount = inCash - outCash;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
        });
    },
    sendToPrintAll(tableData) {
      // window.ipcRenderer = ipcRenderer;
      let data = {
        data: tableData,
        type: "Safe",
        dateRange: this.dateRange,
        title: "تسليم الخزينه",
        img:
          "https://pos.staging.fatura-app.com" +
          JSON.parse(localStorage.getItem("branch")).logo,
      };
      console.log("🚀 ~ sendToPrintAll ~ data:", data)
      // ipcRenderer.send("printing", data);
    },
  },
};
</script>

<style scoped>
.el-table {
  width: 100%;
  max-height: 80%;
  overflow-y: scroll;
}
@media (max-width: 1199px) and (min-width: 767px) {
  .oreder-1 {
    order: 1;
    margin-bottom: 2px;
  }
  .oreder-2 {
    order: 2;
    margin-bottom: 2px;
  }
  .oreder-3 {
    order: 3;
  }
  .oreder-4 {
    order: 4;
  }
}
</style>
